import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output
} from '@angular/core';
import { v4 as uuid } from 'uuid';
import { Subscription } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';

import { DeviceService } from '../../../_services/device.service';
import { IconSizeEnum } from '../../../_enums/icon.enum';
import { SdButtonComponent } from '../../buttons/button/button.component';
import { SdButtonIconComponent } from '../../buttons/button-icon/button-icon.component';
import { ErrorTranslateService } from '../error-translate-service';
import { BaseFormErrorTranslateService } from '../form-common-error/base-form-error-translate.service';

@Component({
  selector: 'sd-form-increment',
  templateUrl: './form-increment.component.html',
  standalone: true,
  imports: [
    SdButtonIconComponent,
    SdButtonComponent,
    FormsModule,
    TranslateModule
  ],
  providers: [
    { provide: BaseFormErrorTranslateService, useClass: ErrorTranslateService }
  ]
})
export class SdFormIncrementComponent implements OnDestroy, OnInit {
  constructor(
    private cdRef: ChangeDetectorRef,
    private deviceService: DeviceService,
  ) {}

  iconSize = IconSizeEnum;
  uuidIncrement: string = uuid();
  mobileSubscription: Subscription;
  isMobile$: boolean;
  selectedChoiceOptionsIdx = 0;
  itemQty;

  @Input()
  labelTitle: string;

  @Input()
  currentValue = 1;

  @Input()
  minValue = 1;

  @Input()
  maxValue = 10;

  @Input()
  choiceOptions: Array<number> = [];

  @Output()
  updateValue = new EventEmitter<number>();

  ngOnInit() {
    if (this.choiceOptions.length) {
      if (!this.choiceOptions.includes(this.currentValue)) {
        this.currentValue = this.choiceOptions[0];
      }
      // Find current index
      this.selectedChoiceOptionsIdx = this.choiceOptions.findIndex(
        (optionNumber: number) => optionNumber === this.currentValue,
      );
    }
    this.mobileSubscription = this.deviceService.isMobile.subscribe((x) => {
      this.isMobile$ = x;
      this.cdRef.markForCheck();
    });

    if (!this.choiceOptions.length) {
      this.itemQty = Array(this.maxValue - this.minValue)
        .fill('')
        .map((x, index) => {
          return this.minValue + index + 1;
        });
    } else {
      this.itemQty = this.choiceOptions.map((x) => {
        return x;
      });
    }
  }

  ngOnDestroy() {
    this.mobileSubscription?.unsubscribe();
  }

  onDecrement() {
    if (this.choiceOptions.length) {
      if (this.selectedChoiceOptionsIdx > 0) {
        this.currentValue = this.choiceOptions[--this.selectedChoiceOptionsIdx];
      }
    } else if (this.currentValue > this.minValue) {
      this.currentValue = this.currentValue - 1;
    }
    this.updateValue.emit(this.currentValue);
  }

  onIncrement() {
    if (this.choiceOptions.length) {
      if (this.selectedChoiceOptionsIdx < this.choiceOptions.length - 1) {
        this.currentValue = this.choiceOptions[++this.selectedChoiceOptionsIdx];
      }
    } else if (this.currentValue < this.maxValue) {
      this.currentValue = this.currentValue + 1;
    }
    this.updateValue.emit(this.currentValue);
  }

  onUpdateValue(event?) {
    if (this.choiceOptions.length) {
      if (!this.choiceOptions.includes(this.currentValue)) {
        // Reset to previous value
        this.currentValue = this.choiceOptions[this.selectedChoiceOptionsIdx];
      } else {
        // Find current index
        this.selectedChoiceOptionsIdx = this.choiceOptions.findIndex(
          (optionNumber: number) => optionNumber === this.currentValue,
        );
      }
    }
    // Manage mobile event while using a default select
    this.currentValue = event?.value
      ? parseInt(event.value)
      : this.currentValue;
    this.updateValue.emit(this.currentValue);
  }
}
